import { isMobileCheck } from '@/utils';

export const strMask = Array(24).fill('a').join('');
export const strFormatChars = { a: '[A-Za-zА-Яа-я\\s\-]' };

export const numberMask = '+7 (999) 999 99-99';
export const numberPlaceholder = '+7 (___)-___ __-__';

export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const isMobile = isMobileCheck();

export const faq = {
    'Как копятся Бонусы?':
        'Для накопления бонусов есть 2 варианта:\n\n' +
        '1) Самостоятельно предлагать друзьям номера (выбирай номер на Главной или в разделах Красивые номера и Выгодные тарифы)\n' +
        '2) Пригласить друга в Другоманию (когда он начнет продавать номера, ты будешь получать по 2 Бонуса за каждую продажу)\n' +
        '\n' +
        'Кроме того, ты можешь получать Пассивный доход - если твой друг продолжает пользоваться номером и своевременно его оплачивать (до последнего числа каждого месяца), ты будешь получать по 100 Бонусов за каждый активный номер\n' +
        '1 Бонус = 1 рубль\n',
    'Как вывести Бонусы':
        'Вывести Бонусы можно только на баланс телефона, который указан у тебя в кабинете. Менять номер телефона можно не чаще одного раза в три месяца\n' +
        'Выведенные Бонусы ты можешь использовать для оплаты собственной сотовой связи\n' +
        'Максимальная сумма вывода Бонусов в месяц - 2000 Б\n' +
        '1 Бонус = 1 рубль\n',
    'Какой курс Бонусов к рублю': '1 Бонус = 1 рубль',
    'Сколько я могу накопить за месяц':
        'Накопление Бонусов не ограничено. Чтобы увеличить количество Бонусов предлагай номера друзьям или приглашай их в Другоманию',
    'Бронь и покупка номеров':
        'После выбора номера ты можешь забронировать его или сразу перейти к покупке.\n' +
        'Бронь позволяет сохранить номер за тобой на сутки.\n' +
        'Например, если ты не знаешь какой из 3 номеров больше понравится твоему другу, забронируй несколько и предложи ему. После того как друг выберет номер, переходи к покупке\n' +
        'Для покупки номера необходимо заполнить обязательные поля, они зависят от способа получения сим-карты\n' +
        'Также не забудь про фото паспорта, без них включить номер не получится (126-ФЗ “О связи”)',
    'Сроки включения номера':
        'Среднее время включения номера после его оплаты - 1 час\n' +
        'Если что-то пойдет не так, другу на контактный номер придет смс с инструкциями что делать дальше',
    'Обслуживание активных номеров': (
        <>
            <p>
                По всем вопросам абоненты могут обращаться в службу круглосуточной поддержки, либо
                написать на почту
                <br />
                Телефон: <a href="tel:+74952478888">+7(495) 247-88-88</a>
                <br />
                WhatsApp: <a href="https://wa.me/74952478888">wa.me/74952478888</a>
                <br />
                Для абонентов Билайн: 0577 (бесплатно)
                <br />
                Почта: <a href="mailto:abonent@k7.ru">abonent@k7.ru</a>
            </p>
            <p>
                Быстрые команды:
                <br />
                <strong>Билайн</strong>
                <br />
                Баланс: *132*11# вызов
                <br />
                Остаток пакетов минут, ГБ и SMS: *132*12# вызов
                <br />
                <strong>Мегафон</strong>
                <br />
                Можно проверить только через «Личный кабинет» или приложение "Мегафон"
                <br />
                <strong>МТС</strong>
                <br />
                Баланс: *100# вызов
                <br />
                Остаток пакетов минут, ГБ и SMS: *100*1# вызов
                <br />
                <strong>Теле2</strong>
                <br />
                Баланс: *105# вызов
                <br />
                Остаток пакетов минут, ГБ и SMS: *155*0# вызов
                <br />
                <strong>Yota</strong>
                <br />
                Баланс: *101# вызов
                <br />
                Остаток пакетов минут, ГБ и SMS: через приложение Yota
            </p>
        </>
    ),
    'Техническая поддержка': (
        <p>
            Если что-то работает неправильно или перестало работать, пожалуйста, сообщите нам об
            этом на почту <a href="mailto:feedback@k7.ru">feedback@k7.ru</a>
            <br />
            График обработки писем: пн-пт с 10 до 19
        </p>
    ),
};
